import { Box, IconButton, Popper } from "@mui/material";
import Grow from "@mui/material/Grow";
import MenuList from "@mui/material/MenuList";
import SvgIcon from "@mui/material/SvgIcon";
import { useEffect, useRef } from "react";
import { theme } from "../styles/theme";
import MapMenuType from "./MapMenuType";
import FilterIcon from "./icons/FilterIcon";
import PointsIcon from "./icons/PointsIcon";

export default function MapPopover({
  children,
  contentFullscreen,
  label,
  buttonId,
  menuId,
  isOpen = false,
  onToggle,
}) {
  const anchorRef = useRef(null);

  const handleToggle = () => {
    if (onToggle && typeof onToggle === "function") {
      onToggle(menuId);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      handleToggle();
    } else if (event.key === "Escape") {
      handleToggle();
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = useRef(isOpen);
  useEffect(() => {
    if (prevOpen.current === true && isOpen === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = isOpen;
  }, [isOpen]);

  return (
    <Box
      sx={{
        [theme.breakpoints.down("md")]: {
          display: label === "Filter" ? "none" : "block",
        },
      }}
    >
      <IconButton
        aria-label={label}
        size="small"
        variant="square-secondary"
        ref={anchorRef}
        id={buttonId}
        aria-controls={isOpen ? "composition-menu" : undefined}
        aria-expanded={isOpen ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <SvgIcon>
          {label === "Legende" ? <PointsIcon /> : <FilterIcon />}
        </SvgIcon>
      </IconButton>
      <Popper
        open={isOpen}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="left-start"
        transition
        disablePortal={false}
        anchororigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ zIndex: 500 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "right top" : "right top",
            }}
          >
            <Box
              sx={{
                "& .MuiPaper-root": {
                  padding: "1rem",
                  borderRadius: "0",
                },
                "& .MuiList-root": {
                  padding: 0,
                },
              }}
            >
              <MapMenuType contentFullscreen={contentFullscreen} type={label}>
                <MenuList
                  id={menuId}
                  aria-labelledby={buttonId}
                  onKeyDown={handleListKeyDown}
                >
                  {children}
                </MenuList>
              </MapMenuType>
            </Box>
          </Grow>
        )}
      </Popper>
    </Box>
  );
}
